import { PurchasedModal } from "./PurchasedModal";

export default PurchasedModal;

